import { Localization } from '../../interfaces/config'

export enum DefaultContainerNames {
  PRODUCT_DETAIL = 'productDetail',
  PRODUCT_DETAIL_META = 'productDetailMeta',
  RECOMMENDED_PRODUCT_DETAIL = 'recommendedProductDetail',
}

export enum DefaultModalContainerNames {
  SEARCH_PRODUCT = 'searchProduct',
  PRODUCT_DETAIL = 'productDetail',
  RECOMMENDED_PRODUCTS = 'recommendedProducts',
  PREFILL_CART = 'prefillCart',
  RECOMMENDED_PRODUCT_DETAIL = 'recommendedProductDetail',
  FILTERS_CLEAR_CONFIRM = 'filtersClearConfirm',
  FILTERS_LIST = 'filtersList',
  LINKED_PRODUCTS = 'linkedProducts',
  CART_ADJUSTMENT = 'cartAdjustment',
  CHECKOUT_SESSION_RULE = 'linkedProductsCheckoutRule',
  CHOSEN_FREEGOODS = 'chosenFreegoods',
  CHOSEN_FREEGOODS_QUANTITY = 'chosenFreegoodsQuantity',
}

export enum ModalStatusPath {
  PRODUCT_DETAIL = '{{default.modals.productDetail}}',
}

export enum DefaultDialogsContainerNames {
  STOCK_ALERT = 'stockAlert',
  CLEAR_CART = 'clearCart',
  VALIDATE_ALCOHOL = 'validateAlcohol',
  VALIDATE_RETURNABLE = 'validateReturnable',
  CONFIRM_ORDER = 'confirmOrder',
  REMOVE_ITEM = 'deleteItemFromCart',
}

// Ideally this would be the union of multiple split enums, but typescript doesn't support that
export enum CinnamonActionNames {
  CLOSE_MODAL = 'closeModal',
  PERFORM_MODAL_ACTIONS = 'performModalActions',
  OPEN_MODAL = 'openModal',
  OPEN_DIALOG = 'openDialog',
  OPEN_LIMIT_DIALOG = 'openLimitDialog',
  CLOSE_DIALOG = 'closeDialog',
  PUSH_VIEW = 'pushView',
  CONDITIONAL_PUSH_VIEW = 'conditionalPushView',
  CLEAR_SEARCH = 'clearSearch',
  REMOVE_ITEM_FROM_CART = 'deleteItemFromCart',
  ADD_ITEM_TO_CART = 'addItemToCart',
  GO_BACK = 'goBack',
  GO_BACK_DYNAMIC = 'goBackDynamic',
  SEARCH = 'search',
  CREATE_ORDER = 'createOrder',
  LOAD_DIALOGS_VALIDATIONS = 'loadDialogsValidations',
  LOG_ACTION = 'logAction',
  GET_PRODUCT_DETAIL = 'productDetail',
  BUNDLES_HANDLER = 'bundlesHandler',
  SET_BUNDLE_COUNT = 'setCurrentBundleCount',
  SET_SUBITEMS = 'setSubitems',
  CLEAR_SUBITEMS = 'clearSubitems',
  CHOSEN_FREEGOODS = 'chosenFreegoods',
  CONFIRM_CHOSEN_FREEGOODS = 'confirmChosenFreegoods',
  UPDATE_QUANTITY_SELECTION_FREEGOOD = 'updateQuantitySelectionFreegood',
  NOTIFY_BACK_IN_STOCK = 'backInStockNotification',
  UPDATE_ITEMS_INPUT = 'adjustProductQuantity',
}

export enum TemplateActionNames {
  CART_DELETE_PRODUCT = 'templateActions.cart.deleteProduct',
  CART_CLEAR_CART = 'templateActions.cart.clearCart',
  CART_PLACE_ORDER = 'templateActions.cart.placeOrder',
  CART_GET_FREQUENTLY_BOUGHT_TOGETHER = 'templateActions.cart.getFrequentlyBoughtTogether',
  CART_CLOSE_RECOMMENDED_PRODUCTS_MODAL = 'templateActions.cart.closeRecommendedProducts',
  CART_UPDATE_RECOMMENDED_PRODUCT_BUTTON = 'templateActions.cart.updateRecommendedButton',
  CART_VIEW_CART_GTM = 'templateActions.cart.viewCartGTM',
  CATALOG_SCROLL_TO_CATEGORY = 'templateActions.catalog.scrollToCategory',
  CATALOG_UPDATE_CATEGORY = 'templateActions.catalog.updateCategory',
  CATALOG_UPDATE_CATEGORY_CATALOG = 'templateActions.catalog.updateCategoryCatalog',
  CATALOG_BANNERS_CLICK = 'templateActions.catalog.bannersClick',
  FILTERS_SET_FILTERS = 'templateActions.filters.setFilters',
  FILTERS_SET_FILTER_CATEGORY = 'templateActions.filters.setFilterCategory',
  FILTERS_CLEAR_FILTERS = 'templateActions.filters.clearFilters',
  FILTERS_GET_FILTERS_RESULTS = 'templateActions.filters.getFilterResults',
  SUGGESTED_ITEMS_FETCH_PRODUCTS = 'templateActions.suggestedItems.fetchProducts',
  BUY_AGAIN_FETCH_PRODUCTS = 'templateActions.buyAgain.fetchProducts',
  PREVIOUSLY_PURCHASED_FETCH_PRODUCTS = 'templateActions.previouslyPurchased.fetchProducts',
  RECOMMENDED_FOR_YOU_FETCH_PRODUCTS = 'templateActions.recommendedForYou.fetchProducts',
  PREFILL_CART_UPDATE_ITEM = 'templateActions.prefillCart.updatePrefillCartItem',
  PREFILL_CART_TO_CART = 'templateActions.prefillCart.prefillCartToCart',
  PLACE_ORDER_FLOW = 'templateActions.placeOrderFlow',
  PLACE_ORDER_FLOW_NEXT = 'templateActions.placeOrderFlowNext',
  PLACE_ORDER_CLEAR = 'templateActions.clearPlaceOrderFlow',
  LINKED_PRODUCTS_GET_ITEMS = 'templateActions.getLinkedProducts',
  LINKED_PRODUCTS_CLOSE_MODAL = 'templateActions.placeOrderFlowClear',
  LINKED_PRODUCTS_VALIDATE_STOCK = 'templateActions.validateLinkedProducts',
  CLOSE_GLOBAL_PROMOTIONS_ALERT = 'templateActions.closeGlobalPromotionsAlert',
  CATEGORIES_NAVIGATION_SET_CATEGORIES = 'templateActions.categoriesNav.setCategoriesNavigation',
  CATEGORIES_NAVIGATION_NAVIGATE_TO_CATEGORY = 'templateActions.categoriesNav.navigateToCategory',
  CATEGORIES_NAVIGATION_GET_PRODUCTS = 'templateActions.categoriesNav.getProducts',
  CATEGORIES_LAZY_GET_PRODUCTS = 'templateActions.categories.lazyGetProducts',
  PRODUCT_DETAIL_ADD_FROM_PROMOTION = 'templateActions.productDetail.addFromPromotion',
  OPEN_ORDER_DETAIL = 'templateActions.orders.openOrderDetail',
  LOAD_MORE_ORDERS = 'templateActions.orders.loadMoreOrders',
  FILTER_ORDERS = 'templateActions.orders.filterOrders',
  REORDER_ITEMS_INTO_CART = 'templateActions.orders.reorderItemsIntoCart',
  BACK_TO_HISTORY = 'templateActions.orders.backToHistory',
  REFRESH_ORDER_DETAIL = 'templateActions.orders.refreshOrderDetail',
  RETURN_TO_CONVERSATION = 'templateActions.orders.returnToConversation',
  REFRESH_ORDER_CONFIRMATION = 'templateActions.orders.refreshOrderConfirmation',
}

export enum DefaultCheckoutRulesNames {
  MIN_AMOUNT_CART_CHECKOUT_RULE = 'comp-min-amount',
  MIN_QTY_CART_CHECKOUT_RULE = 'comp-min-qty',
  MAX_AMOUNT_CART_CHECKOUT_RULE = 'comp-max-amount',
  MAX_QTY_CART_CHECKOUT_RULE = 'comp-max-qty',
  CREDIT_LIMIT_REACHED = 'comp-credit-limit-reached',
}

export const ItemListNameParam = '{{itemListName}}'

export enum CinnamonPaths {
  HOME = '/{{params.slug}}/{{params.sessionId}}',
  CART = '/{{params.slug}}/{{params.sessionId}}/cart',
  SKU_MODAL = '?sku={{this.data.sku}}',
  SKU_MODAL_SEARCH = '?sku={{this.data.sku}}&referrer=',
  SKU_RELATIVE_PARAMS = `/{{params.slug}}/{{params.sessionId}}/product/{{this.data.sku}}?itemListName=${ItemListNameParam}&referrer=`,
  SKU_RELATIVE_RECOMMENDED = `/{{params.slug}}/{{params.sessionId}}/recommended-product/{{this.data.sku}}?itemListName=${ItemListNameParam}`,
  CATEGORIES = '/{{params.slug}}/{{params.sessionId}}/categories',
  FILTERS = '/{{params.slug}}/{{params.sessionId}}/filters',
  SUMMARY = '/{{params.slug}}/{{params.sessionId}}/summary',
  CATEGORIES_NAVIGATION = '/{{params.slug}}/{{params.sessionId}}/categories-nav',
  CATEGORY_NAVIGATION = '/{{params.slug}}/{{params.sessionId}}/category-nav',
  ORDERS = '/{{params.slug}}/{{params.sessionId}}/orders',
  ORDER_DETAIL = '/{{params.slug}}/{{params.sessionId}}/orders/{{this.data.orderId}}',
  ORDER_CONFIRMATION = '/{{params.slug}}/{{params.sessionId}}/order-confirmation',
}

export enum CinnamonVariables {
  SESSION_ID = '{{default.sessionId}}',
  SESSION_DATA = '{{default.sessionData}}',
  STOREFRONT_NAME = '{{default.storeName}}',
  WORKFLOW_ID = '{{default.sessionData.workflow.channelUid}} || {{config.phoneNumber}}',
  CART = '{{cart}}',
  SUMMARY = '{{summary}}',
  LINKED_PRODUCTS_BUTTON_LABEL = '{{cart.linkedProducts.continueButton}}',
}

export enum TextLibrary {
  ACTIONS_ACCEPT = '{{texts.actions.accept}}',
  ACTIONS_CANCEL = '{{texts.actions.cancel}}',
  ACTIONS_YES = '{{texts.actions.yes}}',
  ACTIONS_NO = '{{texts.actions.no}}',
  PRODUCT_STOCK = '{{texts.product.stock}}',
  PRODUCT_WITHOUT_STOCK = '{{texts.product.noStock}}',
  PRODUCT_STOCK_TITLE = '{{texts.product.stockTitle}}',
  PRODUCT_PROMOTION_LIMIT_TITLE = '{{texts.promotions.promotionLimitTitle}}',
  PRODUCT_STOCK_MESSAGE = '{{texts.product.stockMessage}}',
  PRODUCT_MAX_QTY_TITLE = '{{texts.product.maxQtyTitle}}',
  PRODUCT_MAX_QTY_MESSAGE = '{{texts.product.maxQtyMessage}}',
  PRODUCT_PROMOTION_LIMIT_MESSAGE = '{{texts.promotions.promotionLimitMessage}}',
  PRODUCT_UNIT_DISPLAY = '{{texts.product.unitPriceDisplay}}',
  PRODUCT_FEE_DISPLAY = '{{texts.product.feeDisplay}}',
  PRODUCT_TOTAL_AMOUNT = '{{texts.product.totalAmount}}',
  PRODUCT_OUT_OF_STOCK_BUTTON_LABEL = '{{texts.productOutOfStock.buttonLabel}}',
  PRODUCT_OUT_OF_STOCK_DIALOG_CONFIRM = '{{texts.productOutOfStock.dialogConfirm}}',
  PRODUCT_OUT_OF_STOCK_DIALOG_CANCEL = '{{texts.productOutOfStock.dialogCancel}}',
  PRODUCT_OUT_OF_STOCK_DIALOG_TITLE = '{{texts.productOutOfStock.dialogTitle}}',
  CART_TITLE = '{{texts.cart.title}}',
  CART_GO_TO_BUTTON = '{{texts.cart.goToButton}}',
  CART_PROCEED_TO_SUMMARY = '{{texts.cart.proceedToSummary}}',
  CART_PLACE_BUTTON = '{{texts.cart.placeButton}}',
  CART_CLEAR_BUTTON = '{{texts.cart.clearButton}}',
  CART_CLEAR_TITLE = '{{texts.cart.clearTitle}}',
  CART_CLEAR_MESSAGE = '{{texts.cart.clearMessage}}',
  CART_REMOVE_TITLE = '{{texts.cart.removeTitle}}',
  CART_REMOVE_MESSAGE = '{{texts.cart.removeMessage}}',
  CART_EMPTY_TITLE = '{{texts.cart.emptyTitle}}',
  CART_EMPTY_MESSAGE = '{{texts.cart.emptyMessage}}',
  CART_CONFIRM_TITLE = '{{texts.cart.confirmTitle}}',
  CART_CONFIRM_MESSAGE = '{{texts.cart.confirmMessage}}',
  CART_BACK_HOME = '{{texts.cart.backHome}}',
  CART_MINIMUN_MESSAGE = '{{texts.cart.minimunMessage}}',
  CART_CASH_GROUP = '{{texts.cart.cashGroup}}',
  CART_CREDIT_GROUP = '{{texts.cart.creditGroup}}',
  CART_PRODUCTS_GROUP = '{{texts.cart.productsGroup}}',
  CART_PROMOTIONS_GROUP = '{{texts.cart.promotionsGroup}}',
  CART_BOX_GROUP = '{{texts.cart.boxGroup}}',
  CART_UNIT_GROUP = '{{texts.cart.unitGroup}}',
  CART_ADD_TO_CART = '{{texts.cart.addToCart}}',
  CART_DELIVERY_LABEL = '{{texts.cart.deliveryLabel}}',
  CART_DELIVERY_HELPER_TEXT = '{{texts.cart.deliveryHelperText}}',
  CART_PAYMENT_LABEL = '{{texts.cart.paymentLabel}}',
  CART_PAYMENT_HELPER_TEXT = '{{texts.cart.paymentHelperText}}',
  SEARCH_PLACEHOLDER = '{{texts.search.placeholder}}',
  SEARCH_EMPTY_TITLE = '{{texts.search.emptyTitle}}',
  LOADING_MORE_ELEMENTS_TEXT = '{{texts.catalogue.loadingMoreElementsText}}',
  SEARCH_EMPTY_MESSAGE = '{{texts.search.emptyMessage}}',
  SEARCH_NO_RESULT_TITLE = '{{texts.search.noResultTitle}}',
  SEARCH_NO_RESULT_MESSAGE = '{{texts.search.noResultMessage}}',
  SEARCH_RESULTS_TITLE = '{{texts.search.resultsTitle}}',
  TAGS_ALCOHOL = '{{texts.tags.alcohol}}',
  TAGS_RETURNABLE = '{{texts.tags.returnable}}',
  TAGS_SHORT_ALCOHOL = '{{texts.tags.shortAlcohol}}',
  TAGS_SHORT_RETURNABLE = '{{texts.tags.shortReturnable}}',
  TAGS_LINKED_PRODUCTS = '{{texts.tags.linkedProducts}}',
  PREFILL_CART_TITLE = '{{texts.prefillCart.title}}',
  PREFILL_CART_SUBTITLE = '{{texts.prefillCart.subtitle}}',
  PREFILL_CART_SUBTITLE_SINGULAR = '{{texts.prefillCart.subtitleSingular}}',
  RECOMMENDED_PRODUCTS_TITLE = '{{texts.recommendedProducts.title}}',
  RECOMMENDED_PRODUCTS_DECLINE = '{{texts.recommendedProducts.decline}}',
  RECOMMENDED_PRODUCTS_PROCEED = '{{texts.recommendedProducts.proceed}}',
  RECOMMENDED_PRODUCTS_HEADER_TITLE = '{{texts.recommendedProducts.headerTitle}}',
  RECOMMENDED_PRODUCTS_HEADER_BUTTON = '{{texts.recommendedProducts.headerButton}}',
  CREDIT_LIMIT_REACHED = '{{texts.catalogue.creditLimitReached}}',
  EMPTY_CATEGORY_TITLE = '{{texts.catalogue.emptyCategoryTitle}}',
  EMPTY_CATEGORY_MESSAGE = '{{texts.catalogue.emptyCategory}}',
  EMPTY_CATEGORY_BACK_BUTTON = '{{texts.catalogue.backToCategoriesOnEmpty}}',
  SEE_ALL_CATEGORIES_BUTTON = '{{texts.catalogue.seeAllCategories}}',
  ALL_CATEGORIES_LABEL = '{{texts.catalogue.allCategories}}',
  CATEGORIES_LABEL = '{{texts.catalogue.categories}}',
  FILTERS_VIEW_TITLE = '{{texts.filters.title}}',
  FILTERS_APPLY_BUTTON_TEXT = '{{texts.filters.buttonText}}',
  FILTERS_CLEAR_BUTTON_TEXT = '{{texts.filters.clearText}}',
  FILTERS_MODAL_CLEAR_TITLE = '{{texts.filters.clearModalTitle}}',
  FILTERS_MODAL_BUTTON_OK = '{{texts.filters.clearModalButtonOK}}',
  FILTERS_MODAL_BUTTON_CANCEL = '{{texts.filters.clearModalButtonCancel}}',
  FILTERS_ALL_PRODUCTS_LABEL = '{{texts.filters.allProductsLabel}}',
  FILTERS_EMPTY_RESULT = '{{texts.filters.emptyResult}}',
  FILTERS_EMPTY_RESULT_DESCRIPTION = '{{texts.filters.emptyResultDescription}}',
  SUGGESTED_ITEMS_TITLE = '{{texts.suggestedItems.title}}',
  SUGGESTED_ITEMS_EMPTY_RESULT = '{{texts.suggestedItems.emptyResult}}',
  SUGGESTED_ITEMS_EMPTY_RESULT_DESCRIPTION = '{{texts.suggestedItems.emptyResultDescription}}',
  SUGGESTED_ITEMS_SUBTITLE = '{{texts.suggestedItems.subtitle}}',
  BUY_AGAIN_HEADER_TITLE = '{{texts.buyAgain.headerTitle}}',
  BUY_AGAIN_HEADER_BUTTON = '{{texts.buyAgain.headerButton}}',
  BUY_AGAIN_LIST_TITLE = '{{texts.buyAgain.listTitle}}',
  BUY_AGAIN_EMPTY_RESULT = '{{texts.buyAgain.emptyResult}}',
  BUY_AGAIN_EMPTY_RESULT_DESCRIPTION = '{{texts.buyAgain.emptyResultDescription}}',
  PREVIOUSLY_PURCHASED_HEADER_TITLE = '{{texts.previouslyPurchased.headerTitle}}',
  PREVIOUSLY_PURCHASED_HEADER_BUTTON = '{{texts.previouslyPurchased.headerButton}}',
  PREVIOUSLY_PURCHASED_LIST_TITLE = '{{texts.previouslyPurchased.listTitle}}',
  PREVIOUSLY_PURCHASED_EMPTY_RESULT = '{{texts.previouslyPurchased.emptyResult}}',
  PREVIOUSLY_PURCHASED_EMPTY_RESULT_DESCRIPTION = '{{texts.previouslyPurchased.emptyResultDescription}}',
  RECOMMENDED_FOR_YOU_HEADER_TITLE = '{{texts.recommendedForYou.headerTitle}}',
  RECOMMENDED_FOR_YOU_HEADER_BUTTON = '{{texts.recommendedForYou.headerButton}}',
  RECOMMENDED_FOR_YOU_LIST_TITLE = '{{texts.recommendedForYou.listTitle}}',
  RECOMMENDED_FOR_YOU_EMPTY_RESULT = '{{texts.recommendedForYou.emptyResult}}',
  RECOMMENDED_FOR_YOU_EMPTY_RESULT_DESCRIPTION = '{{texts.recommendedForYou.emptyResultDescription}}',
  ALTERNATIVE_PRODUCTS_HEADER_TITLE = '{{texts.alternativeProducts.headerTitle}}',
  LINKED_PRODUCTS_HEADING = '{{texts.linkedProducts.heading}}',
  LINKED_PRODUCTS_CONTINUE = '{{texts.linkedProducts.continue}}',
  LINKED_PRODUCTS_CONTINUE_WITHOUT = '{{texts.linkedProducts.continueWithout}}',
  SUMMARY_TITLE = '{{texts.summary.title}}',
  SUMMARY_SUBTITLE = '{{texts.summary.subtitle}}',
  SUMMARY_UNITS_LABEL = '{{texts.summary.unitsLabel}}',
  SUMMARY_TOTAL_LABEL = '{{texts.summary.totalLabel}}',
  SUMMARY_SIDE_LABEL = '{{texts.summary.sideLabel}}',
  SUMMARY_SUBTOTAL_LABEL = '{{texts.summary.subtotalLabel}}',
  SUMMARY_CONTINUE_BUTTON = '{{texts.summary.continue}}',
  SUMMARY_HEADING_QUANTITY = '{{texts.summary.headingQuantity}}',
  SUMMARY_HEADING_PRODUCT = '{{texts.summary.headingProduct}}',
  SUMMARY_HEADING_SUBTOTAL = '{{texts.summary.headingSubtotal}}',
  SUMMARY_DISCOUNTS_LABEL = '{{texts.summary.discountsLabel}}',
  SUMMARY_TAXES_LABEL = '{{texts.summary.taxesLabel}}',
  SUMMARY_PERCEPTIONS_LABEL = '{{texts.summary.perceptionsLabel}}',
  SUMMARY_ADMINISTRATIVE_SERVICE_LABEL = '{{texts.summary.administrativeServiceLabel}}',
  SUMMARY_ALERT_ON_MIN_AMOUNT = '{{texts.summary.alertOnMinAmount}}',
  CART_SERVICE_LABEL = '{{texts.cart.serviceLabel}}',
  CART_MATERIAL_LABEL = '{{texts.cart.materialLabel}}',
  CART_PERCEPTION_LABEL = '{{texts.cart.perceptionLabel}}',
  CART_MAX_QTY_ALERT = '{{texts.cart.warningLabel}}',
  CART_RESTRICTIONS_LABEL = '{{texts.cart.restrictionsLabel}}',
  CART_TOTAL_LABEL = '{{texts.cart.totalCartFooter}}',
  CART_ITEMS_COUNTER = '{{texts.cart.itemsCounter}}',
  CART_PRICE_TEXT = '{{texts.cart.price}}',
  CHOSEN_FREEGOODS_HEADER = '{{texts.chosenFreegoods.heading}}',
  CHOSEN_FREEGOODS_DESCRIPTION = '{{texts.chosenFreegoods.description}}',
  CHOSEN_FREEGOODS_CONFIRM = '{{texts.chosenFreegoods.confirmLabel}}',
  CHOSEN_FREEGOODS_REJECT = '{{texts.chosenFreegoods.rejectLabel}}',
  BUNDLE_LIST_TITLE = '{{texts.bundles.title}}',
  BUNDLE_LIST_DESCRIPTION_COUNTERS = '{{texts.bundles.descriptionForCounters}}',
  BUNDLE_LIST_DESCRIPTION_CHECKBOX = '{{texts.bundles.descriptionForCheckBox}}',
  BUNDLE_LIST_DESCRIPTION_RADIO = '{{texts.bundles.descriptionForRadio}}',
  BUNDLE_LIST_SELECT_BUTTON_LABEL = '{{texts.bundles.selectButtonLabel}}',
  PACKAGE_LIST_DESCRIPTION = '{{texts.packages.description}}',
  PACKAGE_LIST_TITLE = '{{texts.packages.title}}',
  PACKAGE_LIST_OUT_OFF_STOCK = '{{texts.packages.outOfStock}}',
  DEFAULT_PROMOTION_LABEL = '{{texts.promotions.defaultPromotionLabel}}',
  PROMOTION_ADD_LABEL = '{{texts.promotions.addLabel}}',
  CART_FREEGOODS_LIST_LABEL = '{{texts.cart.freeGoodsListLabel}}',
  CART_PRODUCT_GROUP_UNITS_SINGULAR = '{{texts.cart.productGroupUnitsSingular}}',
  CART_PRODUCT_GROUP_UNITS_PLURAL = '{{texts.cart.productGroupUnitsPlural}}',
  ORDER_CONFIRMATION_ORDER_LABEL = '{{texts.orderConfirmation.orderLabel}}',
  ORDER_CONFIRMATION_ITEMS_LABEL = '{{texts.orderConfirmation.itemsLabel}}',
  ORDER_CONFIRMATION_QUANTITY_LABEL = '{{texts.orderConfirmation.quantityLabel}}',
  ORDER_CONFIRMATION_TOTAL_LABEL = '{{texts.orderConfirmation.totalLabel}}',
  /*
   * The delivery and payment rows, shipped with `1.20.0` — the release that
   * added the props. They were deliberately withheld at `1.19.1`, where the
   * panel had none of them and spreads unrecognised props onto its styled
   * wrapper, so a token would have drawn a stray DOM attribute and nothing on
   * screen, with no diagnostic.
   *
   * The placeholders are the reserved-space pair: a storefront that authors
   * them gets the row drawn with placeholder copy before the data exists,
   * which is what M1-C fills in. Authoring only the labels is also valid — the
   * row then appears when the order carries the field and not before.
   *
   * `ORDER_CONFIRMATION_REFRESH_LABEL` was withheld on the older form of the
   * same rule — there was no `REFRESH_ORDER_CONFIRMATION` action, so the token
   * would have let an author draw a styled, inert button. That action exists
   * as of COM-930 and the token ships below, beside the return label.
   *
   * There is no token for `paymentMethodLabels`. It is a map from the
   * backend's payment enum to a tenant's word for it, not a text slot — a
   * config author writes the object and may use `{{texts.…}}` tokens for its
   * values.
   */
  ORDER_CONFIRMATION_DELIVERY_LABEL = '{{texts.orderConfirmation.deliveryLabel}}',
  ORDER_CONFIRMATION_PAYMENT_LABEL = '{{texts.orderConfirmation.paymentLabel}}',
  ORDER_CONFIRMATION_DELIVERY_PLACEHOLDER = '{{texts.orderConfirmation.deliveryPlaceholder}}',
  ORDER_CONFIRMATION_PAYMENT_PLACEHOLDER = '{{texts.orderConfirmation.paymentPlaceholder}}',
  ORDER_CONFIRMATION_DECLINE_REASON_LABEL = '{{texts.orderConfirmation.declineReasonLabel}}',
  ORDER_CONFIRMATION_RETURN_LABEL = '{{texts.orderConfirmation.returnLabel}}',
  /**
   * The refresh control's label, and one of the things that draw it.
   * `OrderConfirmationPanel` gates the control on
   * `status === 'unknown' && !!onRefresh && !!refreshLabel &&
   * fieldsToDisplay.refresh !== false`, so this token is necessary and, on its
   * own, not remotely sufficient.
   *
   * **Shipping it is safe only because the handler is the other half.** A
   * storefront that authors this label and no `onRefresh` gets no control at
   * all — not a button that emits nowhere — which is the anti-requirement
   * COM-930 was written around and is pinned in
   * `templates/tests/OrderConfirmation.template.test.tsx`.
   *
   * **Copy and prop are different things here, and only one of them has a
   * default.** The copy does: `texts.orderConfirmation.refreshLabel` ships in
   * all seven `defaultTexts` files (#730 added the namespace, COM-930 this
   * key), exactly as `texts.orders.detail.refreshLabel` does for the sibling
   * constant — the two are alike in this, and an earlier revision of this
   * comment drew a contrast with `ORDERS_DETAIL_REFRESH_LABEL` that was simply
   * false. The panel **props** have no default and never will: `onRefresh` and
   * `refreshLabel` are authored per storefront in SCS config, and a storefront
   * that authors neither sees no control. So shipping copy is not what makes
   * this token safe to ship, and the unresolved-token reasoning on the sibling
   * constant is not what protects it either. The handler half is.
   *
   * Pairs with `TemplateActionNames.REFRESH_ORDER_CONFIRMATION`, which
   * `EventManager` registers onto `useOrderActions.refreshOrderConfirmation`.
   * **Authoring the label beside an `onRefresh` the emitter cannot usefully
   * call draws a live-looking control that does nothing**, and no count of
   * such shapes belongs in this comment — they are a class, not a list. What
   * they have in common is that `processActions` never consults a registry, so
   * whatever a storefront authors reaches the panel's `!!onRefresh` gate and
   * passes it. Known members, all verified in source: a name that is not this
   * one (`EventEmitter.emit` returns silently for an unregistered name); an
   * empty `cinnamonActions` array (the reduce never emits at all); an entry
   * with no `name`; and `onRefresh` authored as a **bare string**, which
   * `processActions` does not even convert, its `typeof propValue === 'object'`
   * test being false — so the string survives onto the prop, passes the gate,
   * and throws `TypeError` on click. Only the first is pinned by a test;
   * see that test for why this is characterised rather than fixed.
   */
  ORDER_CONFIRMATION_REFRESH_LABEL = '{{texts.orderConfirmation.refreshLabel}}',
  ORDER_CONFIRMATION_CREATING_TITLE = '{{texts.orderConfirmation.creating.title}}',
  ORDER_CONFIRMATION_CREATING_MESSAGE = '{{texts.orderConfirmation.creating.message}}',
  ORDER_CONFIRMATION_PENDING_TITLE = '{{texts.orderConfirmation.pending.title}}',
  ORDER_CONFIRMATION_PENDING_MESSAGE = '{{texts.orderConfirmation.pending.message}}',
  ORDER_CONFIRMATION_CREATED_TITLE = '{{texts.orderConfirmation.created.title}}',
  ORDER_CONFIRMATION_CREATED_MESSAGE = '{{texts.orderConfirmation.created.message}}',
  ORDER_CONFIRMATION_CONFIRMED_TITLE = '{{texts.orderConfirmation.confirmed.title}}',
  ORDER_CONFIRMATION_CONFIRMED_MESSAGE = '{{texts.orderConfirmation.confirmed.message}}',
  ORDER_CONFIRMATION_FAILED_TITLE = '{{texts.orderConfirmation.failed.title}}',
  ORDER_CONFIRMATION_FAILED_MESSAGE = '{{texts.orderConfirmation.failed.message}}',
  ORDER_CONFIRMATION_UNKNOWN_TITLE = '{{texts.orderConfirmation.unknown.title}}',
  ORDER_CONFIRMATION_UNKNOWN_MESSAGE = '{{texts.orderConfirmation.unknown.message}}',
  ORDERS_TITLE = '{{texts.orders.title}}',
  ORDERS_EMPTY_TITLE = '{{texts.orders.emptyTitle}}',
  ORDERS_EMPTY_MESSAGE = '{{texts.orders.emptyMessage}}',
  ORDERS_ERROR_TITLE = '{{texts.orders.errorTitle}}',
  ORDERS_ERROR_MESSAGE = '{{texts.orders.errorMessage}}',
  ORDERS_RETRY_LABEL = '{{texts.orders.retryLabel}}',
  ORDERS_ALL_FILTER_LABEL = '{{texts.orders.allFilterLabel}}',
  ORDERS_ORDER_LABEL = '{{texts.orders.orderLabel}}',
  ORDERS_ITEMS_LABEL = '{{texts.orders.itemsLabel}}',
  ORDERS_REORDER_LABEL = '{{texts.orders.reorderLabel}}',
  ORDERS_REORDER_PARTIAL_MESSAGE = '{{texts.orders.reorderPartialMessage}}',
  ORDERS_REORDER_ERROR_MESSAGE = '{{texts.orders.reorderErrorMessage}}',
  ORDERS_STATUS_CREATED = '{{texts.orders.status.CREATED}}',
  ORDERS_STATUS_CONFIRMED = '{{texts.orders.status.CONFIRMED}}',
  ORDERS_STATUS_SUGGESTED = '{{texts.orders.status.SUGGESTED}}',
  ORDERS_STATUS_WAITING_CALLBACK = '{{texts.orders.status.WAITING_CALLBACK}}',
  ORDERS_STATUS_IN_PROGRESS = '{{texts.orders.status.IN_PROGRESS}}',
  ORDERS_STATUS_PROCESSED = '{{texts.orders.status.PROCESSED}}',
  ORDERS_STATUS_PAID = '{{texts.orders.status.PAID}}',
  ORDERS_STATUS_SENT = '{{texts.orders.status.SENT}}',
  ORDERS_STATUS_SHIPPED = '{{texts.orders.status.SHIPPED}}',
  ORDERS_STATUS_DELIVERED = '{{texts.orders.status.DELIVERED}}',
  ORDERS_STATUS_EDITED = '{{texts.orders.status.EDITED}}',
  ORDERS_STATUS_ERROR = '{{texts.orders.status.ERROR}}',
  ORDERS_STATUS_CANCELLED = '{{texts.orders.status.CANCELLED}}',
  /*
   * Order Detail. A `detail` sub-namespace under the `orders` namespace
   * COM-725 opened, rather than more siblings beside it: the screens share a
   * vocabulary but not their copy. `orderLabel`, `itemsLabel` and
   * `reorderLabel` above are shared and are not repeated here; everything
   * below has no list-level counterpart, and the four state messages that do
   * — error, not found — say something different on a screen showing one
   * order than on a screen showing none.
   */
  ORDERS_DETAIL_QUANTITY_LABEL = '{{texts.orders.detail.quantityLabel}}',
  ORDERS_DETAIL_SUBTOTAL_LABEL = '{{texts.orders.detail.subtotalLabel}}',
  ORDERS_DETAIL_DISCOUNTS_LABEL = '{{texts.orders.detail.discountsLabel}}',
  ORDERS_DETAIL_FEE_LABEL = '{{texts.orders.detail.feeLabel}}',
  ORDERS_DETAIL_TOTAL_LABEL = '{{texts.orders.detail.totalLabel}}',
  ORDERS_DETAIL_PAYMENT_LABEL = '{{texts.orders.detail.paymentLabel}}',
  ORDERS_DETAIL_DELIVERY_LABEL = '{{texts.orders.detail.deliveryLabel}}',
  /*
   * The heading over the supplying depot's name (COM-889). Placed between
   * delivery and address to match where the panel draws it, which is a matter
   * of the library's hand-written JSX and of nothing else. `ORDER_DETAIL_FIELDS`
   * — which lives in `@engyalo/delivery-ui-components`, not in this repo —
   * happens to list the keys in the same order, but it is a key list for
   * `fieldsToDisplay` and a drift guard over the field union; reordering it
   * would not reorder a single row. This placement is therefore a courtesy to
   * the next reader, not a binding.
   *
   * Ships a default in all seven `defaultTexts` files, and the mechanism it
   * labels ships with it: `OrderDetailPanel` declares `distributorLabel` as of
   * `1.21.1`, which this repo now pins. Authoring a token ahead of its prop is
   * how a tenant gets a stray DOM attribute and nothing on screen — see the
   * note on the delivery and payment tokens, which were withheld for exactly
   * that reason while `1.19.1` was pinned.
   *
   * It fails **blank**, not closed, and unusually that is the safe direction
   * here. A storefront that authors the panel without the copy renders the
   * depot name under an empty heading, because the panel defaults every label
   * to `''` and gates the row on the *value* rather than on the label — the
   * inverse of `refreshLabel` below, where the label is half of what draws the
   * control. What makes the blank case rare rather than merely tolerable is
   * that the default copy ships fleet-wide, so reaching it takes a storefront
   * that has overridden `texts.orders.detail` with an object of its own.
   */
  ORDERS_DETAIL_DISTRIBUTOR_LABEL = '{{texts.orders.detail.distributorLabel}}',
  ORDERS_DETAIL_ADDRESS_LABEL = '{{texts.orders.detail.addressLabel}}',
  ORDERS_DETAIL_BACK_LABEL = '{{texts.orders.detail.backLabel}}',
  /*
   * The refresh action's label, and half of what draws it: `OrderDetailPanel`
   * renders the control only where `onRefresh` **and** `refreshLabel` are both
   * truthy, and defaults the label to `''`.
   *
   * That conjunction is what makes an unresolved label safe: a storefront that
   * authors `onRefresh` beside a label that resolves to nothing gets no
   * control at all rather than a full-width blank button.
   *
   * **It is no longer the namespace that leaves it unresolved.** This comment
   * used to say that no `defaultTexts` file ships anything under
   * `texts.orders`, and #730 made that false — all seven carry the namespace,
   * `detail.refreshLabel` included, and `processConfig` deep-merges them under
   * every storefront config, so this token resolves to real copy wherever a
   * tenant authors it and supplies none of its own. **Nothing pins that**: the
   * `orderTextsDefaults` test this comment used to cite does not exist in the
   * repo — verify against the seven `defaultTexts/*.json` files themselves
   * before relying on the key being present.
   *
   * What is still unauthored fleet-wide is the **prop wiring**: no
   * `defaultProps` binds either half, so the operand that actually decides
   * whether the detail control draws is `onRefresh`. The unresolved-label case survives as a tenant's own
   * authoring mistake: a typo'd token, or a namespace its own config
   * overwrote — which is the case the mechanism below is about.
   *
   * **The safety depends on which `processData` pass has the last word.**
   * `composeResult` has two branches for an unresolved whole-value variable.
   * At config time `processConfig.getComponentsProps` passes `initial: true`
   * and the token is **echoed back as a literal**, deliberately, so it can be
   * resolved later against live state. Only the render-time pass in
   * `useCinnamonProps` — `initial` false — returns `undefined`, which is what
   * lets the panel's `''` default apply. So the property is "the last
   * resolution wins and it yields `undefined`", not "an unresolved token is
   * falsy": a value that reached the panel straight off the config pass would
   * arrive as the truthy string `'{{texts.orders.detail.refreshLabel}}'` and
   * draw a button captioned with the template expression.
   *
   * Authoring both halves is what a shopper on `timeout` needs, since the
   * panel hides the order body in that state and this is the only way to see
   * the order again without leaving the screen.
   */
  ORDERS_DETAIL_REFRESH_LABEL = '{{texts.orders.detail.refreshLabel}}',
  ORDERS_DETAIL_PENDING_TITLE = '{{texts.orders.detail.pendingTitle}}',
  ORDERS_DETAIL_PENDING_MESSAGE = '{{texts.orders.detail.pendingMessage}}',
  ORDERS_DETAIL_TIMEOUT_TITLE = '{{texts.orders.detail.timeoutTitle}}',
  ORDERS_DETAIL_TIMEOUT_MESSAGE = '{{texts.orders.detail.timeoutMessage}}',
  ORDERS_DETAIL_ERROR_TITLE = '{{texts.orders.detail.errorTitle}}',
  ORDERS_DETAIL_ERROR_MESSAGE = '{{texts.orders.detail.errorMessage}}',
  /*
   * One copy for both. The server answers "no such order" and "not yours"
   * with the same 404 so that a probe cannot confirm an id names a real
   * order, and copy that distinguished them would give away exactly what the
   * status code withholds.
   */
  ORDERS_DETAIL_NOT_FOUND_TITLE = '{{texts.orders.detail.notFoundTitle}}',
  ORDERS_DETAIL_NOT_FOUND_MESSAGE = '{{texts.orders.detail.notFoundMessage}}',
  ORDERS_DETAIL_SESSION_ENDED_TITLE = '{{texts.orders.detail.sessionEndedTitle}}',
  ORDERS_DETAIL_SESSION_ENDED_MESSAGE = '{{texts.orders.detail.sessionEndedMessage}}',
  /*
   * The two M2 picker screens (COM-947). A namespace each rather than a
   * shared `checkout` one: the screens ask different questions, and the only
   * copy they would share is a confirm button, which is a word rather than a
   * vocabulary.
   *
   * Five keys apiece, which is what a picker cannot render without — a
   * heading, a line of guidance, the confirm action, and the two states that
   * are not a list of options. COM-948 and COM-949 add whatever their panels
   * turn out to need; seeding more now would ship tokens with no props behind
   * them, the mistake the delivery and payment rows on `orderConfirmation`
   * avoided by waiting for `1.20.0`.
   *
   * Unlike the `orders.*` namespace when it landed, these ship real copy in
   * all seven `defaultTexts` files, so a storefront that authors a container
   * and forgets the copy gets sentences rather than blank labels. A tenant
   * overrides them the usual way; `processConfig` deep-merges its config over
   * these.
   *
   * ⚠️ **`emptyStateMessage` is not a spinner.** An empty offer is a real
   * answer from the server: `DELIVERY_DATES` can filter its one computed day
   * out for being today, and `PAYMENT_METHODS` comes back empty for any tenant
   * whose `paymentRules.default` is authored but empty. The screens must tell
   * that apart from "not fetched yet", which is why `checkoutSlice` keys
   * `loadingState` separately from `data`.
   *
   * Not the pilot, for payment — a 2026-09-23 capture returned one method.
   */
  DELIVERY_DATE_HEADER_LABEL = '{{texts.deliveryDate.headerLabel}}',
  DELIVERY_DATE_HELPER_TEXT = '{{texts.deliveryDate.helperText}}',
  DELIVERY_DATE_CONFIRM_BUTTON_LABEL = '{{texts.deliveryDate.confirmButtonLabel}}',
  DELIVERY_DATE_EMPTY_STATE_MESSAGE = '{{texts.deliveryDate.emptyStateMessage}}',
  DELIVERY_DATE_ERROR_MESSAGE = '{{texts.deliveryDate.errorMessage}}',
  PAYMENT_METHOD_HEADER_LABEL = '{{texts.paymentMethod.headerLabel}}',
  PAYMENT_METHOD_HELPER_TEXT = '{{texts.paymentMethod.helperText}}',
  PAYMENT_METHOD_CONFIRM_BUTTON_LABEL = '{{texts.paymentMethod.confirmButtonLabel}}',
  PAYMENT_METHOD_EMPTY_STATE_MESSAGE = '{{texts.paymentMethod.emptyStateMessage}}',
  PAYMENT_METHOD_ERROR_MESSAGE = '{{texts.paymentMethod.errorMessage}}',
}

export enum Referrers {
  PREFILL_CART = 'PREFILL_CART',
  FREQUENTLY_BOUGHT_TOGETHER = 'FREQUENTLY_BOUGHT_TOGETHER',
  SUGGESTED_ITEMS = 'SUGGESTED_ITEMS',
  LINKED_PRODUCTS = 'LINKED_PRODUCTS',
  PROMOTION_DETAIL = 'PROMOTION_DETAIL',
  SEARCH = 'SEARCH',
  BUY_AGAIN = 'BUY_AGAIN',
  PREVIOUSLY_PURCHASED = 'PREVIOUSLY_PURCHASED',
  RECOMMENDED_FOR_YOU = 'RECOMMENDED_FOR_YOU',
  ALTERNATIVE_PRODUCTS = 'ALTERNATIVE_PRODUCTS',
  ORDER_HISTORY_REORDER = 'ORDER_HISTORY_REORDER',
}

export const FIRST_PAGE_NUMBER = 1
export const PRODUCTS_PAGE_SIZE = 10
export const CATEGORIES_PAGE_SIZE = 25
export const CATEGORIES_PAGE_SIZE_NAVIGATION = 50
export const PREFILL_CART_LIMIT = 100

/**
 * Defaults for the productized recommendation placements.
 *
 * These are the values `globals.recommendedProducts` ships with, not values any
 * component reads directly: the placements bind to the global so a storefront
 * can retune them from SCS. Changing a number here changes the fleet default.
 */
export const RECOMMENDATION_CAROUSEL_LIMIT = 15
export const RECOMMENDATION_LIST_LIMIT = 50

export const WHATSAPP_ME_URL = 'http://wa.me/'
export const LINE_ME_URL = 'https://line.me/R/oaMessage/'
export const CHATBOT_WARNING_ICON =
  'https://storage.googleapis.com/commerce-cinnamon-production/images/assets/assistant_warning.svg'

export enum PackageType {
  HALFBOX = 'HALF BOX',
  UNIT = 'UNIT',
}

export const EMPTY_STRING = ''
export const SlashSymbol = '/'
export const TrueEnv = 'true'
export const LOCAL_ENV_NAME = 'localhost'

export const MAXIMUM_NUMBER_OF_GLOBAL_TOTAL_PROMOTIONS_ALERT = 3
export const GOOGLE_TAG_MANAGER_DATA_LAYER_NAME = 'CinnamonDataLayer'
export const GOOGLE_TAG_LOAD_EVENT = 'commerce-webview_load'
export const TextDirMap: Record<
  Localization,
  React.HTMLAttributes<HTMLDivElement>['dir']
> = {
  [Localization.En]: 'ltr',
  [Localization.Es]: 'ltr',
  [Localization.Pt]: 'ltr',
  [Localization.Zh]: 'ltr',
  [Localization.Ar]: 'rtl',
  [Localization.EnUs]: 'ltr',
  [Localization.EsMx]: 'ltr',
  [Localization.PtBr]: 'ltr',
  [Localization.ZhCn]: 'ltr',
  [Localization.He]: 'rtl',
  [Localization.Th]: 'ltr',
}
